import { useState } from "react";

/**
 * 专家相关状态 Hook
 */
const useExpertState = () => {
  const [experts, setExperts] = useState([]);
  const [selectedExpert, setSelectedExpert] = useState(null);
  const [isInExpertMode, setIsInExpertMode] = useState(false);
  const [currentExpertCommand, setCurrentExpertCommand] = useState('');
  const [lastExpertSummaryCheck, setLastExpertSummaryCheck] = useState({ command: '', timestamp: 0 });
  const [isExpertDropdownOpen, setIsExpertDropdownOpen] = useState(false);
  const [expertSearchTerm, setExpertSearchTerm] = useState('');
  const [selectedExpertCategory, setSelectedExpertCategory] = useState('全部');
  const [isExpertDialogReady, setIsExpertDialogReady] = useState(false);
  const [expertDialogContent, setExpertDialogContent] = useState(null);
  const [pendingExperts, setPendingExperts] = useState([]);
  const [expertFlashMap, setExpertFlashMap] = useState({}); // { [fileId]: true } 新消息 3s 脉冲
  const [expertUnreadMap, setExpertUnreadMap] = useState({}); // { [fileId]: true } 未读小红点（持续，直到切入该 tab 才清除）

  // 重置专家状态
  const resetExpertState = () => {
    setExperts([]);
    setSelectedExpert(null);
    setIsInExpertMode(false);
    setCurrentExpertCommand('');
    setLastExpertSummaryCheck({ command: '', timestamp: 0 });
    setIsExpertDropdownOpen(false);
    setExpertSearchTerm('');
    setSelectedExpertCategory('全部');
    setIsExpertDialogReady(false);
    setExpertDialogContent(null);
    setPendingExperts([]);
    setExpertFlashMap({});
    setExpertUnreadMap({});
  };

  return {
    experts,
    setExperts,
    selectedExpert,
    setSelectedExpert,
    isInExpertMode,
    setIsInExpertMode,
    currentExpertCommand,
    setCurrentExpertCommand,
    lastExpertSummaryCheck,
    setLastExpertSummaryCheck,
    isExpertDropdownOpen,
    setIsExpertDropdownOpen,
    expertSearchTerm,
    setExpertSearchTerm,
    selectedExpertCategory,
    setSelectedExpertCategory,
    isExpertDialogReady,
    setIsExpertDialogReady,
    expertDialogContent,
    setExpertDialogContent,
    pendingExperts,
    setPendingExperts,
    expertFlashMap,
    setExpertFlashMap,
    expertUnreadMap,
    setExpertUnreadMap,
    resetExpertState,
  };
};

export default useExpertState;
